// Microsoft 365 quick-action deep links (Home hero + left-rail block).
// The prototype scaffolded these buttons dead (spec §2 "pending
// integration"); until real Graph-embedded surfaces land, they deep-link to
// the M365 web apps in a new tab — the signed-in Entra session carries over.

export const M365_LINKS = {
  email: 'https://outlook.office.com/mail/',
  calendar: 'https://outlook.office.com/calendar/',
  planner: 'https://planner.cloud.microsoft/',
} as const;

export function openM365(target: keyof typeof M365_LINKS): void {
  window.open(M365_LINKS[target], '_blank', 'noopener');
}
